import { ADDITIONAL_INFO_MAX_LENGTH, RENOVATION_ADDITIONAL_INFO_MAX_LENGTH } from '@shared/sec-loans'
import { validateTextArea } from '@ui-common/utils/validation'
import { FieldName } from 'react-hook-form'
import { IntlShape } from 'react-intl'
import { create, omitWhen, only, Suite } from 'vest'

import { WizardData } from '../../../types'
import { TargetAdditionalInfoFormData as FormData } from './types'

export const createFormValidator = (
  formatMessage: IntlShape['formatMessage'],
  applicationData: WizardData,
): Suite<string, string, (data: FormData, changedFields?: FieldName<FormData>[]) => void> => {
  return create((data, changedFields) => {
    only(changedFields)

    const hasRenovations =
      !!applicationData.targetInfo?.renovationsInfoData?.renovationsAmount ||
      !!applicationData.targetInfo?.renovationsInfoData?.otherPurchasesAmount

    const isAdditionalInfoRequired = false

    validateTextArea(
      formatMessage,
      'additionalInfo',
      data.additionalInfo,
      ADDITIONAL_INFO_MAX_LENGTH,
      isAdditionalInfoRequired,
    )

    omitWhen(!hasRenovations, () => {
      validateTextArea(
        formatMessage,
        'additionalRenovationsInfo',
        data.additionalRenovationsInfo,
        RENOVATION_ADDITIONAL_INFO_MAX_LENGTH,
        true,
      )
    })
  })
}
